'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactTable = require('react-table');

var _reactTable2 = _interopRequireDefault(_reactTable);

var _IconButton = require('material-ui/IconButton');

var _IconButton2 = _interopRequireDefault(_IconButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {

    var columns = [{
        id: 'edit',
        width: 62,
        Cell: function Cell(col) {
            return _react2.default.createElement(
                _IconButton2.default,
                { iconClassName: 'material-icons', onClick: function onClick() {
                        return props.onClickEditInstitution(col.original.id);
                    } },
                'edit'
            );
        } /// me mudar
    }, {
        Header: 'Id',
        accessor: 'id',
        width: 240
    }, {
        Header: 'Nome',
        accessor: 'name'
    }];

    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_reactTable2.default, {
            data: props.institutions,
            columns: columns,
            loading: props.loading,
            previousText: 'Anterior',
            nextText: 'Pr\xF3xima',
            loadingText: 'Carregando...',
            noDataText: 'N\xE3o foram encontrados org\xE3os para este filtro',
            pageText: 'P\xE1gina',
            ofText: 'de',
            rowsText: 'linhas',
            showPaginationBottom: true,
            width: 100,
            defaultPageSize: 10,
            filterable: true
        })
    );
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/client/components/institution/InstitutionList.js
// module id = 3280
// module chunks = 0